var exports = {
  "U": "xfd349460--34fcaf--name",
};

module.exports = exports;
